import { Body1, makeStyles, Subtitle2, tokens } from '@fluentui/react-components'
import { Save32Regular, StarEmphasis32Regular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingVerticalS,
    flex: 1,
  },
  starIcon: {
    color: tokens.colorPaletteMarigoldBackground3,
  },
  title: {
    textAlign: 'center',
  },
  description: {
    textAlign: 'center',
    color: tokens.colorNeutralForeground2,
    maxWidth: '80vw',
  },
})

interface EmptyPromptsContentProps {
  variant: 'favorites' | 'custom'
}

const EmptyPromptsContent = ({ variant }: EmptyPromptsContentProps) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const Icon = variant === 'favorites' ? StarEmphasis32Regular : Save32Regular

  return (
    <div className={classes.container}>
      <Icon
        className={variant === 'favorites' ? classes.starIcon : undefined}
        aria-hidden="true"
        data-testid={`empty-prompts-icon-${variant}`}
      />
      <Subtitle2 as="p" className={classes.title}>
        {t(`prompts.empty.${variant}.title`)}
      </Subtitle2>
      <Body1 as="p" className={classes.description}>
        {t(`prompts.empty.${variant}.description`)}
      </Body1>
    </div>
  )
}

export { EmptyPromptsContent }
